/** The one public name. Use this instead of scattering product strings. */
export const APP_NAME = "Sermon Space";

export const APP_EVENTS = {
  openSearch: "sermonspace:open-search",
  openFind: "sermonspace:open-find",
  syncConflict: "sermonspace:sync-conflict",
  documentSynced: "sermonspace:document-synced",
  outboxChanged: "sermonspace:outbox-changed",
} as const;
